import { gql } from '@apollo/client';

export const ChangeKnowledgeDataText = gql`
    mutation changeKnowledgeDataText($knowledgeDataId: ID!, $text: String!) {
        changeKnowledgeDataText(knowledgeDataId: $knowledgeDataId, text: $text) {
            ... on UploadedKnowledgeDataSuccessType {
                message
                knowledgeData {
                    id
                    source
                    active
                    sourceType
                    text
                    createdAt
                }
            }
            ... on ErrorType {
                message
            }
        }
    }
`;
